import { RewardType } from '@bonanza-social/rewards';
import { RewardsTextConfig } from './RewardsText.types';

export const REWARD_TEXT_CONFIG: RewardsTextConfig = {
  [RewardType.FreeSpins]: {
    icon: 'freeSpins',
    text: 'freeSpins',
  },
  [RewardType.Coins]: {
    icon: 'bonanzaCoin',
    text: 'bonanzaCoins',
  },
  [RewardType.InstantWheel]: {
    icon: 'rewardWheel',
    text: 'wheelSpins',
  },
  [RewardType.Cash]: {
    icon: 'bonanzaDollar',
  },
};
